if (!customElements.get('interwood-hero-slider')) {
  customElements.define('interwood-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.indicators = Array.from(this.querySelectorAll('[data-interwood-indicator]'));
      this.status = this.querySelector('[data-slide-status]');
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayDelay = Number(this.dataset.autoplayDelay) || 7000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.isHovered = false;
      this.isFocused = false;
      this.pointerStartX = null;
      this.resumeTimer = null;

      if (this.slides.length < 2 || this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.addEventListener('click', (event) => {
        const control = event.target.closest('[data-interwood-previous], [data-interwood-next], [data-interwood-indicator]');
        if (!control) return;
        if (control.hasAttribute('data-interwood-previous')) this.userNavigate(this.currentIndex - 1);
        if (control.hasAttribute('data-interwood-next')) this.userNavigate(this.currentIndex + 1);
        if (control.hasAttribute('data-interwood-indicator')) this.userNavigate(Number(control.dataset.interwoodIndicator));
      }, true);

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.userNavigate(this.currentIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.userNavigate(this.currentIndex + 1); }
      });

      this.addEventListener('mouseenter', () => { this.isHovered = true; this.stopAutoplay(); });
      this.addEventListener('mouseleave', () => { this.isHovered = false; this.startAutoplay(); });
      this.addEventListener('focusin', () => { this.isFocused = true; this.stopAutoplay(); });
      this.addEventListener('focusout', (event) => {
        if (this.contains(event.relatedTarget)) return;
        this.isFocused = false;
        this.startAutoplay();
      });

      this.addEventListener('pointerdown', (event) => {
        if (event.target.closest('a, button')) return;
        this.pointerStartX = event.clientX;
        this.setPointerCapture?.(event.pointerId);
        this.stopAutoplay();
      }, { passive: true });
      this.addEventListener('pointerup', (event) => {
        if (this.pointerStartX === null) return;
        const distance = event.clientX - this.pointerStartX;
        this.pointerStartX = null;
        if (Math.abs(distance) >= 45) this.userNavigate(this.currentIndex + (distance < 0 ? 1 : -1));
      }, { passive: true });
      this.addEventListener('pointercancel', () => { this.pointerStartX = null; this.startAutoplay(); });

      this.reducedMotion.addEventListener?.('change', () => this.startAutoplay());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      });

      this.updateSlides(this.currentIndex, false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      window.clearTimeout(this.resumeTimer);
    }

    normalizeIndex(index) { return (index + this.slides.length) % this.slides.length; }

    updateSlides(index, announce = true) {
      this.currentIndex = this.normalizeIndex(index);
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.querySelectorAll('[data-slide-link]').forEach((link) => { link.tabIndex = isActive ? 0 : -1; });
      });
      this.indicators.forEach((indicator, indicatorIndex) => {
        const isActive = indicatorIndex === this.currentIndex;
        indicator.classList.toggle('is-active', isActive);
        indicator.setAttribute('aria-current', String(isActive));
      });
      if (announce && this.status) this.status.textContent = `Slide ${this.currentIndex + 1} of ${this.slides.length}`;
    }

    userNavigate(index) {
      this.updateSlides(index);
      this.stopAutoplay();
      window.clearTimeout(this.resumeTimer);
      this.resumeTimer = window.setTimeout(() => this.startAutoplay(), 12000);
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.autoplayEnabled || this.reducedMotion.matches || this.isHovered || this.isFocused || document.hidden) return;
      this.autoplayTimer = window.setInterval(() => this.updateSlides(this.currentIndex + 1, false), this.autoplayDelay);
    }

    stopAutoplay() {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  });
}
